import axios, { AxiosResponse } from 'axios';
import { IhostspotRequest } from '../../types/hotspot';

export const PRODUCT_HOTSPOT = `/product-hotspot`;
/**
 * Hotspot for product
 */

// @TODO: Change the older hotspots naming to feedback-hotspots and rename newer one to hotspots from product-hotspots

export const saveProductHotspot = (id: string): Promise<AxiosResponse<any>> => {
    // console.log('save Hotspot to productions:');
    return axios.post(`${PRODUCT_HOTSPOT}/save/${id}`);
};

export const createProductHotspot = (id: string, request: any): Promise<AxiosResponse<any>> => {
    // console.log('createProductHotspot:', request);
    // remove comment field from request
    if (request.comment === '') {
        delete request.comment;
    }
    return axios.post(`${PRODUCT_HOTSPOT}/create/${id}`, request);
};

export const fetchAllProductHotspots = (id: string): Promise<AxiosResponse<any>> => {
    return axios.get(`${PRODUCT_HOTSPOT}/${id}`);
};

export const getHotSpotInfo = (fsn: string): Promise<AxiosResponse<any>> => {
    return axios.get(`${PRODUCT_HOTSPOT}/info/${fsn}`);
};

export const deleteHotspot = (id?: string): Promise<AxiosResponse<any>> => {
    return axios.delete(`${PRODUCT_HOTSPOT}/delete/${id}`);
};

export const deleteHotSpotInfo = (id?: string): Promise<AxiosResponse<any>> => {
    return axios.delete(`${PRODUCT_HOTSPOT}/${id}`);
};

export const fetchHotspotInfoData = (pid: string, id: string): Promise<AxiosResponse<any>> => {
    return axios.get(`${PRODUCT_HOTSPOT}/${pid}/${id}`);
};

export const searchHotSpotsFromCsv = (file): Promise<AxiosResponse<any>> => {
    /**
     * Sending CSV in form data
     */
    const formData = new FormData();
    formData.append('type', 'formData');
    formData.append('file', file[0]);

    return axios.post(`${PRODUCT_HOTSPOT}/search/fsns`, formData);
};

export const searchProductForHotSpots = (fsn: string): Promise<AxiosResponse<any>> => {
    return axios.get(`${PRODUCT_HOTSPOT}/search/${fsn}`);
};
